import React from 'react';
import { FlaskConical } from 'lucide-react';

/**
 * "Demo — simulated data" bar, styled like EnvironmentBadge.
 */
const DemoNotice = ({ message = 'Demo — simulated data' }) => (
  <div className="flex items-center gap-2 px-3 py-2 border border-zinc-300 bg-zinc-50 font-mono text-xs uppercase tracking-[0.15em] text-zinc-600">
    <FlaskConical className="w-3.5 h-3.5 text-zinc-500 flex-shrink-0" />
    <span>{message}</span>
  </div>
);

export default DemoNotice;
